/**
 * PDF 出力に送る日誌データの組み立て（issue #995）。
 *
 * 既存の「PDFで出力する」（pdf-api）と「PDFで出力する（新レイアウト・試行中）」（backend の rust-pdf）の
 * 両方のボタンで共通に使う。
 */

/**
 * 現場巡視の記録を平坦化する
 *
 * 画面では `[{ site: [record, ...] }, ...]` の形で持っているが、PDF には record の配列で渡す。
 *
 * @param {Array} sitePatrolRecords 画面の現場巡視の記録
 * @returns {Array} 平坦化した記録
 */
export function flattenSitePatrolRecords(sitePatrolRecords) {
  const flattened = [];
  for (const sitePatrol of sitePatrolRecords || []) {
    if (sitePatrol.site && Array.isArray(sitePatrol.site)) {
      for (const site of sitePatrol.site) {
        flattened.push(site);
      }
    }
  }
  return flattened;
}

/**
 * PDF 用の日誌データを組み立てる
 *
 * siteMetaData はここでは含めない（呼び出し側で現場のメタ情報を取得してから付ける）。
 *
 * @param {Object} diaryData Vuex の日誌データ（getDiaryRevisions）
 * @param {Object} meta
 * @param {string} meta.title PDF のタイトル
 * @param {string} meta.createdAt 作成日時（"YYYY年MM月DD日 HH:mm"）
 * @param {string} meta.year 作成年（"YYYY"）
 * @param {*} meta.latestEditAs 編集モード
 * @returns {Object} PDF 用の日誌データ
 */
export function buildPdfPayload(diaryData, { title, createdAt, year, latestEditAs }) {
  return {
    ...diaryData,
    title,
    created_at: createdAt,
    year,
    latestEditAs,
    sitePatrolRecords: flattenSitePatrolRecords(diaryData.sitePatrolRecords),
  };
}

export default {
  buildPdfPayload,
  flattenSitePatrolRecords,
};
